import * as React from "react";
import { useNavigate } from "react-router-dom";
import { linksOf } from "../../../services/cpln";
import { Command } from "../../../schema/types/command";
import { BasePathContext } from "../../../reactContexts/basePathContext";
import { parseLink } from "../../../utils/linkParser/linkParser";
import { subSeconds, addWeeks, addSeconds, differenceInDays } from "date-fns";
import { Button } from "antd";

interface Props {
  command: Command;
  containerName?: string;
}
export const CommandActions: React.FC<Props> = ({ command, containerName }) => {
  const navigate = useNavigate();
  const basePath = React.useContext(BasePathContext);

  if (command.type !== "runCronWorkload") {
    return null;
  }

  const info = React.useMemo(() => {
    const { name: workloadName, gvc: workloadGvc } = parseLink(linksOf(command).target!, { useInputCtx: true });
    return { workloadName, workloadGvc };
  }, [command]);
  const { workloadName, workloadGvc } = info;

  const fromDate = React.useMemo(() => {
    const createdDate = new Date(command.created);
    // Subtract 1 second for buffer
    return subSeconds(createdDate, 1).toISOString();
  }, [command]);

  // Limit time to 7 days
  let toDate = "";
  const now = new Date();
  const createdDate = new Date(command.created);
  if (differenceInDays(now, createdDate) > 7) {
    // Add 1 second buffer to the end date
    const limitedCompletionDate = addSeconds(addWeeks(createdDate, 1), 1);
    toDate = limitedCompletionDate.toISOString();
  }

  // Times are UTC ISO strings, so set tz=UTC to ensure logs page displays in UTC
  const logLink = `${basePath}/logs?query=${encodeURIComponent(
    `{gvc="${workloadGvc}", location="${command.spec!.location}", workload="${workloadName}", replica="${
      command.status?.replica
    }"}`,
  )}&from=${fromDate}${
    toDate ? `&to=${toDate}` : ""
  }&tz=UTC&execute=true&live=${!toDate && command.lifecycleStage === "running" ? "true" : "false"}`;

  let connectLink = "";
  if (containerName) {
    connectLink = `${basePath}/connect?location=${command.spec!.location}&container=${containerName}&replica=${
      command.status?.replica
    }&autoConnect=true`;
  }

  return (
    <div className="flex items-center gap-2 mb-4">
      <Button type="primary" onClick={() => navigate(logLink)} disabled={!command.status?.replica}>
        See Logs
      </Button>
      {connectLink ? (
        <Button type="primary" onClick={() => navigate(connectLink)} disabled={command.lifecycleStage !== "running"}>
          Connect {command.lifecycleStage !== "running" ? `(Not Running)` : ""}
        </Button>
      ) : null}
    </div>
  );
};
